import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const OutSourcing = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("OutSourcing", "outsourcing/outsourcing_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.OutSourcing || { Main: {}, FAQ: [] };

  const [activeIndex, setActiveIndex] = useState(0);
  const toggleItem = (index) => setActiveIndex(activeIndex === index ? null : index);

  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '', phone: '' });
  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, subject, message, phone } = formData;
    const data = { name, email, subject, message, phone, language };
    try {
      const response = await fetch('/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      alert(response.ok ? (result.success || LANGUAGE.Main.AlertSuccess) : (result.error || LANGUAGE.Main.AlertFail));
    } catch (error) {
      alert(LANGUAGE.Main.AlertFail);
    }
  };

  return (
    <div>
      {/* Outsourcing FAQ Section */}
      <div className="container-fluid outsourcing py-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="pb-5">
                <h1 className="display-4">{LANGUAGE.Main.Title1}</h1>
                <h4 className="text-primary">{LANGUAGE.Main.Subtitle1}</h4>
              </div>
              <div className="accordion bg-light rounded p-4">
                {LANGUAGE.FAQ.map((item, index) => (
                  <div className="accordion-item border-0 mb-4" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button text-dark fs-5 fw-bold rounded-top ${activeIndex === index ? "" : "collapsed"}`}
                        type="button"
                        onClick={() => toggleItem(index)}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}>
                      <div className="accordion-body my-2">
                        <h5>{item.answerTitle}</h5>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="outsourcing-img RotateMoveRight rounded">
                <img src="img/outsourcing-img.jpg" className="img-fluid rounded w-100" alt="Outsourcing" />
                <a className="outsourcing-btn btn btn-primary rounded-pill text-white py-3 px-5" href="#contact">
                  {LANGUAGE.Main.CTA1}<i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: '600px' }}>
            <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Title2}</h5>
            <h1 className="mb-0">{LANGUAGE.Main.Subtitle2}</h1>
          </div>
          <div className="row g-5">
            <div className="col-lg-4 col-md-6">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon"><i className="fa fa-shield-alt text-white"></i></div>
                <h4 className="mb-3">{LANGUAGE.Main.Feature1}</h4>
                <p className="m-0">{LANGUAGE.Main.FeatureDesc1}</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon"><i className="fa fa-wallet text-white"></i></div>
                <h4 className="mb-3">{LANGUAGE.Main.Feature2}</h4>
                <p className="m-0">{LANGUAGE.Main.FeatureDesc2}</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon"><i className="fa fa-user-shield text-white"></i></div>
                <h4 className="mb-3">{LANGUAGE.Main.Feature3}</h4>
                <p className="m-0">{LANGUAGE.Main.FeatureDesc3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutSourcing;
